import EntityType from '@enums/EntityType';

/**
 * Performs a safety check to return only valid tags or untagged.
 *
 * @param {Object} - entity
 * @param {Object} - library
 *
 * @return {Array<string>}
 */
export default function resolveEntityTagIds(entity, library) {
  const raw = entity.tags;
  if (!raw?.length) {
    return [EntityType.UNTAGGED];
  }

  const valid = [];
  for (let i = 0; i < raw.length; i++) {
    const id = raw[i];
    if (id === EntityType.UNTAGGED) {
      valid.push(id);
      continue;
    }
    const tag = library.tags.tags.map.get(id);
    if (tag?.__taggables_set.has(entity.__type)) {
      valid.push(id);
    }
  }

  return valid.length ? valid : [EntityType.UNTAGGED];
}
